import React, { useState, useMemo, useCallback } from "react";
import {
  Dropdown,
  ButtonDisclosure,
  Badge,
  DSProvider,
} from "@toddle-edu/ds-web";
import { FilterOutlined } from "@toddle-edu/ds-icons";
import { useI18n } from "Hooks";
import classes from "./StandardFilter.scss";
import FiltersOverlay from "UIComponents/FiltersOverlay/FiltersOverlay";
import {
  DEFAULT_STANDARD_FILTERS,
  getFilterOverlayOptions,
  getAllFiltersCount,
  getAppliedFiltersCountForFilter,
} from "../../Utils";

const StandardFilter = ({
  subjects = [],
  grades = [],
  tags = [],
  disabled = false,
  updatePost,
  setStandardFilters,
  standardFilters,
}) => {
  const { t } = useI18n(["common"]);

  const [showDropdown, setShowDropdown] = useState(false);

  const filterOverlayOptions = getFilterOverlayOptions({
    t,
    grades,
    subjects,
    tags,
  });
  const appliedFiltersCount = useMemo(
    () => getAllFiltersCount({ currentFilters: standardFilters }),
    [standardFilters]
  );

  const onApplyFilterOverlay = useCallback(({ filters }) => {
    updatePost({ standardFilters: filters });
    setStandardFilters(filters);
    setShowDropdown(false);
  }, []);

  const onCloseFilterOverlay = useCallback(() => setShowDropdown(false), []);
  const getPopupContainer = useCallback(() => document.body, []);
  return (
    <DSProvider dsVersion="2.0">
      <div className={classes.container}>
        <Dropdown
          placement="bottomLeft"
          visible={showDropdown}
          disabled={disabled}
          onVisibleChange={setShowDropdown}
          getPopupContainer={getPopupContainer}
          overlay={
            <FiltersOverlay
              options={filterOverlayOptions}
              currentFilters={standardFilters} // state
              getAllFiltersCount={getAllFiltersCount}
              getAppliedFiltersCountForFilter={getAppliedFiltersCountForFilter}
              onApply={onApplyFilterOverlay}
              handleClose={onCloseFilterOverlay}
              defaultFilters={DEFAULT_STANDARD_FILTERS}
            />
          }
        >
          <ButtonDisclosure
            icon={<FilterOutlined />}
            type="outlined"
            variant="neutral"
            size="medium"
            testId="standardFilter-button"
            dsVersion="2.0"
          >
            {appliedFiltersCount > 0 ? (
              <span className={classes.filterBtn}>
                <span>{t("common:filters")}</span>
                <Badge
                  value={appliedFiltersCount}
                  type="numeric"
                  variant="dark"
                  shape="circle"
                />
              </span>
            ) : (
              t("common:filters")
            )}
          </ButtonDisclosure>
        </Dropdown>
      </div>
    </DSProvider>
  );
};

export default StandardFilter;
